import { render, staticRenderFns } from "./ScrollView.vue?vue&type=template&id=7c8da7d7&scoped=true&"
import script from "./ScrollView.vue?vue&type=script&lang=js&"
export * from "./ScrollView.vue?vue&type=script&lang=js&"
import style0 from "./ScrollView.vue?vue&type=style&index=0&id=7c8da7d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8da7d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\69\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8da7d7')) {
      api.createRecord('7c8da7d7', component.options)
    } else {
      api.reload('7c8da7d7', component.options)
    }
    module.hot.accept("./ScrollView.vue?vue&type=template&id=7c8da7d7&scoped=true&", function () {
      api.rerender('7c8da7d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/ScrollView.vue"
export default component.exports